import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";

const Create = () => {
  const { checkRequiredFields } = useRequiredFields();
  const navigate = useNavigate();
  const { type } = useParams();
  const [inputs, setInputs] = useState({ type, mushok_6_4_show: true }); // initialized type from useParams
  const [unit, setUnit] = useState([]);
  const [unitSupply, setUnitSupply] = useState([]);
  // const [category, setCategory] = useState([]);
  const [error, setError] = useState({});
  const [departments, setDepartments] = useState([]); // For storing factory data
  const [finishedGoodsDepartments, setfinishedGoodsDepartments] = useState([]);
  const [selectedFactoryOption, setSelectedFactoryOption] = useState(null);

  const [showAccountsForm, setShowAccountsForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [receipt, setReceipt] = useState(null);
  const [role, setRole] = useState({});
  useEffect(() => {
    setLoading(true);
    // if (inputs.type === "finished_goods") {
    //   setShowAccountsForm(true);
    // } else {
    //   setShowAccountsForm(false);
    // }

    const fetchData = async () => {
      try {
        // const unitData = await Http.get("/unitSelect2");
        const role = await Http.get("/staff-type-check");
        setRole(role.data);
        // const categoryData = await Http.get("/productCatSelect2");
        // const codeData = await Http.get(
        //   "/last-code-increment-by-one/products/code/P"
        // );
        // if (inputs.type === "raw_materials") {
        //   const codeData = await Http.get(
        //     "/last-code-increment-by-one/products/code/RM"
        //   );
        //   setReceipt(codeData.data);
        // } else if (inputs.type === "packing_materials") {
        //   const codeData = await Http.get(
        //     "/last-code-increment-by-one/products/code/PM"
        //   );
        //   setReceipt(codeData.data);
        // } else if (inputs.type === "finished_goods") {
        //   const codeData = await Http.get(
        //     "/last-code-increment-by-one/products/code/FG"
        //   );
        //   setReceipt(codeData.data);
        // } else if (inputs.type === "spare_parts") {
        //   const codeData = await Http.get(
        //     "/last-code-increment-by-one/products/code/SP"
        //   );
        //   setReceipt(codeData.data);
        // }

        // let codeEndpoint = "";

        // switch (inputs.type) {
        //   case "raw_materials":
        //     codeEndpoint = "/last-code-increment-by-one/products/code/RM";
        //     break;
        //   case "packing_materials":
        //     codeEndpoint = "/last-code-increment-by-one/products/code/PM";
        //     break;
        //   case "finished_goods":
        //     codeEndpoint = "/last-code-increment-by-one/products/code/FG";
        //     break;
        //   case "spare_parts":
        //     codeEndpoint = "/last-code-increment-by-one/products/code/SP";
        //     break;
        //   default:
        //     codeEndpoint = "/last-code-increment-by-one/products/code/P";
        // }

        // const codeData = await Http.get(codeEndpoint);

        // const departmentRes = await Http.get("/departmentArtSelect2");
        // setDepartments(departmentRes.data);
        // const selectedDepartments = departmentRes.data.filter(
        //   (dept) => dept.value === 2 || dept.value === 3
        // );
        // setfinishedGoodsDepartments(selectedDepartments);

        // Set default factory option
        // const selectedFactory = factoryRes.data.find(
        //   (factory) => factory.id === productRes.data.location_id
        // );
        // if (selectedFactory) {
        //   setSelectedFactoryOption({
        //     label: selectedFactory.name,
        //     value: selectedFactory.id,
        //   });
        // }

        // setUnit(unitData.data);
        // setUnitSupply(unitData.data);
        // setCategory(categoryData.data);
        // setInputs((prevInputs) => ({
        //   ...prevInputs,
        //   // code: codeData.data,
        // }));
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [inputs.type]);

  // const selectHandleChange = (selectedOption, actionMeta) => {
  //   const name = actionMeta.name;
  //   const value = selectedOption.value;
  //   if (actionMeta.name === "department_art_id") {
  //     setSelectedFactoryOption({
  //       label: selectedOption.label,
  //       value: selectedOption.value,
  //     });
  //   }

  //   setInputs((values) => ({ ...values, [name]: value }));
  // };

  const handleChange = (e) => {
    const name = e.target.name;
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // Default Load
  // const fetchData = async () => {
  //   const unitData = await Http.get("/unitSelect2");
  //   const categoryData = await Http.get("/productCatSelect2");
  //   const codeData = await Http.get("/last-code-increment-by-one/products/code/P");

  //   setUnit(unitData.data);
  //   setUnitSupply(unitData.data);
  //   setCategory(categoryData.data);
  //   setInputs((prevInputs) => ({
  //     ...prevInputs,
  //     code: codeData.data,
  //   }));
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  // useEffect(() => {
  //   if (inputs.type === "finished_goods") {
  //     setShowAccountsForm(true);
  //   } else {
  //     setShowAccountsForm(false);
  //   }
  // }, [inputs.type]);

  const formSubmit = (e) => {
    e.preventDefault();
    const isValid = checkRequiredFields();
    // setInputs((prevInputs) => ({ ...prevInputs, type: type }));
    Http.post("/create-pending-product", { ...inputs, status: "pending", type: "raw_materials", store_id: 15, department_art_id:1  })
      .then((res) => {
        navigate("/product", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  console.log(inputs.type, "inputs.type");

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create RM Names</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Create RM Names</h6>
            {/* <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div> */}
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Name <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                      data-required
                    />
                  </div>
                </div>

                {/* {showAccountsForm && ( */}
                {/* <>
                  <div className="row mt-5">
                    <div className="col-md-12 mb-3">
                      <h4 className="text-center">Accounts</h4>
                      <hr />
                    </div>

                    <div className="col-lg-6">
                      <label>STD For Accounts:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="std_price_accounts"
                        value={inputs.std_price_accounts || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6">
                      <label>Vat For Accounts:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="vat_value_accounts"
                        value={inputs.vat_value_accounts || ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-12 mt-5">
                      <h4 className="text-center">চালান</h4>
                      <hr />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-lg">
                      <label>একক মূল্য(টাকায়):</label>
                      <input
                        type="text"
                        className="form-control"
                        name="sdv_inv"
                        value={inputs.sdv_inv || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg">
                      <label>সম্পুরক শুল্কের হার:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="sd_inv"
                        value={inputs.sd_inv || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg">
                      <label>মূল্য সংযোজন করের হার/সুনির্দিষ্ট কর:</label>
                      <input
                        type="text"
                        className="form-control"
                        name="vat_inv"
                        value={inputs.vat_inv || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg">
                    <label>
                      সরবরাহের একক: <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={unitSupply[0]}
                      name="unit_supply"
                      options={unitSupply}
                      onChange={selectHandleChange}
                    />
                  </div>
                    <div className="col-lg">
                    <label>
                      পরিমাণ: <i className="fa fa-star required"></i>
                    </label>
                    <input type="text" className="form-control" name="unit_supply_qty" value={inputs.unit_supply_qty || ""} onChange={handleChange} />
                  </div>
                  </div>
                  <div className="row mt-3">
                    
                  </div>
                </> */}
                {/* )} */}

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Create;
